function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _Button = require("../Button");
var Icons = _interopRequireWildcard(require("../Icons"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["currentItem", "totalItems", "label", "onPress", "isNumbered", "showEllipsis", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var Pagination = exports.Pagination = (0, _react.memo)(function (_ref) {
  var currentItem = _ref.currentItem,
    totalItems = _ref.totalItems,
    label = _ref.label,
    _onPress = _ref.onPress,
    _ref$isNumbered = _ref.isNumbered,
    isNumbered = _ref$isNumbered === void 0 ? false : _ref$isNumbered,
    _ref$showEllipsis = _ref.showEllipsis,
    showEllipsis = _ref$showEllipsis === void 0 ? false : _ref$showEllipsis,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _isPointerOver = _useState2[0],
    _setIsPointerOver = _useState2[1];
  var _onPointerEnter = function _onPointerEnter(index) {
    _setIsPointerOver(index);
  };
  var _onPointerLeave = function _onPointerLeave() {
    _setIsPointerOver(null);
  };
  var _lastIndex = totalItems - 1;
  var _showEllipsis = showEllipsis && _lastIndex > 5;
  var hideLabel = _showEllipsis || isNumbered ? false : true;
  var _useStyles = (0, _styles.useStyles)({
      hideLabel: hideLabel
    }),
    styles = _useStyles.styles;
  var Ellipsis = function Ellipsis() {
    return (0, _jsxRuntime.jsx)(_reactNative.Text, {
      style: styles.ellipsis,
      children: "..."
    });
  };
  return (0, _jsxRuntime.jsxs)(_reactNative.View, Object.assign({
    style: [styles.paging, style],
    testID: "Pagination"
  }, props, {
    children: [(0, _jsxRuntime.jsx)(_Button.Button, {
      type: _Button.ButtonType.blank,
      ariaLabel: "".concat(label, " ").concat(currentItem > 1 ? currentItem - 1 + 1 : 1, " of ").concat(totalItems),
      icon: Icons.LeftChevron,
      hideLabel: true,
      textStyle: [styles.pagingItem, _isPointerOver === -1 && currentItem !== 0 && styles.pagingItem_pointerOver],
      state: {
        disabled: currentItem === 0
      },
      onPress: function onPress() {
        return _onPress == null ? void 0 : _onPress(currentItem - 1);
      },
      iconContainerStyle: styles.iconContainer,
      iconStyle: styles.iconLeft,
      testID: "BackButton",
      nativeContainerStyle: styles.pagingItemNativeContainer,
      onPointerEnter: function onPointerEnter() {
        return _onPointerEnter(-1);
      },
      onPointerLeave: _onPointerLeave
    }), isNumbered && (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: new Array(totalItems).fill('').map(function (_, index) {
        var _showItem = !_showEllipsis || index === 0 || index === _lastIndex || index === currentItem || currentItem < 3 && index < 4 || currentItem > _lastIndex - 2 && index > _lastIndex - 4 || index === currentItem - 1 || index === currentItem + 1;
        var _showPreEllipsis = _showEllipsis && index === _lastIndex && currentItem < _lastIndex - 2;
        var _showPostEllipsis = _showEllipsis && index === 0 && currentItem > 2;
        if (!_showItem) return null;
        return (0, _jsxRuntime.jsxs)(_react["default"].Fragment, {
          children: [_showPreEllipsis && (0, _jsxRuntime.jsx)(Ellipsis, {}), (0, _jsxRuntime.jsx)(_Button.Button, {
            testID: "PagingItem",
            ariaLabel: "".concat(label, " ").concat(index + 1, " of ").concat(totalItems),
            label: "".concat(index + 1),
            textStyle: [styles.pagingItem, currentItem === index && styles.pagingItem_current, _isPointerOver === index && styles.pagingItem_pointerOver],
            onPress: function onPress() {
              return _onPress == null ? void 0 : _onPress(index);
            },
            type: _Button.ButtonType.blank,
            hideLabel: hideLabel,
            nativeContainerStyle: styles.pagingItemNativeContainer,
            onPointerEnter: function onPointerEnter() {
              return _onPointerEnter(index);
            },
            onPointerLeave: _onPointerLeave
          }), _showPostEllipsis && (0, _jsxRuntime.jsx)(Ellipsis, {})]
        }, "page-".concat(index));
      })
    }), (0, _jsxRuntime.jsx)(_Button.Button, {
      type: _Button.ButtonType.blank,
      ariaLabel: "".concat(label, " ").concat(currentItem > 1 ? currentItem + 1 + 1 : 1, " of ").concat(totalItems),
      icon: Icons.RightChevron,
      hideLabel: true,
      textStyle: [styles.pagingItem, _isPointerOver === _lastIndex + 1 && currentItem !== _lastIndex && styles.pagingItem_pointerOver],
      state: {
        disabled: currentItem === _lastIndex
      },
      onPress: function onPress() {
        _onPress == null ? void 0 : _onPress(currentItem + 1);
      },
      iconContainerStyle: styles.iconContainer,
      iconStyle: styles.iconRight,
      testID: "ForwardButton",
      nativeContainerStyle: styles.pagingItemNativeContainer,
      onPointerEnter: function onPointerEnter() {
        return _onPointerEnter(_lastIndex + 1);
      },
      onPointerLeave: _onPointerLeave
    })]
  }));
});